(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat).replace(/<[^>]*>/g, '').trim();
    }

    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  function readConfig(section) {
    var configEl = section.querySelector('[data-complete-set-config]');
    if (!configEl) return null;

    try {
      return JSON.parse(configEl.textContent);
    } catch (error) {
      console.error('Complete the set config parse error:', error);
      return null;
    }
  }

  function getLiveMainVariantId() {
    var input = document.querySelector('[data-product-variant-id], form[action*="/cart/add"] input[name="id"]');
    return input && input.value ? String(input.value) : '';
  }

  function getVariantOptionValue(variant, optionIndex) {
    if (!variant) return '';

    if (optionIndex === 1) return variant.option2 || variant.label || '';
    if (optionIndex === 2) return variant.option3 || variant.label || '';
    return variant.option1 || variant.label || '';
  }

  function getVariantLabel(variant, optionIndex) {
    if (!variant) return '';
    return getVariantOptionValue(variant, optionIndex) || variant.label || variant.name || '';
  }

  function getCompareCents(variant) {
    if (!variant) return 0;
    var compare = variant.compareAtPrice || variant.compare_at_price || 0;
    if (compare > 0) return compare;
    return variant.price || 0;
  }

  function findMainVariant(config, variantId) {
    if (!config || !config.mainVariants) return null;

    for (var i = 0; i < config.mainVariants.length; i++) {
      if (String(config.mainVariants[i].id) === String(variantId)) {
        return config.mainVariants[i];
      }
    }

    return null;
  }

  function enrichMainVariant(configVariant, eventVariant) {
    if (!eventVariant) return configVariant;

    var merged = configVariant ? Object.assign({}, configVariant) : {
      id: eventVariant.id,
      label: eventVariant.name || eventVariant.option1 || '',
      option1: eventVariant.option1 || '',
      option2: eventVariant.option2 || '',
      option3: eventVariant.option3 || '',
      price: eventVariant.price || 0,
      compareAtPrice: eventVariant.compare_at_price || 0,
      priceFormatted: eventVariant.price_formatted || '',
      available: eventVariant.available !== false,
      image: eventVariant.featured_image_full || null
    };

    if (eventVariant.price_formatted) merged.priceFormatted = eventVariant.price_formatted;
    if (eventVariant.price != null) merged.price = eventVariant.price;
    if (eventVariant.compare_at_price != null) merged.compareAtPrice = eventVariant.compare_at_price;
    if (eventVariant.featured_image_full) merged.image = eventVariant.featured_image_full;
    if (eventVariant.option1) merged.option1 = eventVariant.option1;
    if (eventVariant.name) merged.label = eventVariant.name;
    if (eventVariant.available != null) merged.available = eventVariant.available;

    return merged;
  }

  function findMatchedPairVariant(pairProduct, mainVariant, optionIndex) {
    if (!pairProduct || !pairProduct.variants || !pairProduct.variants.length) return null;

    var target = getVariantOptionValue(mainVariant, optionIndex);
    var normalizedTarget = target ? String(target).trim().toLowerCase() : '';

    if (normalizedTarget) {
      for (var i = 0; i < pairProduct.variants.length; i++) {
        var candidate = pairProduct.variants[i];
        var candidateValue = getVariantOptionValue(candidate, optionIndex);
        if (
          candidate.available &&
          candidateValue &&
          String(candidateValue).trim().toLowerCase() === normalizedTarget
        ) {
          return candidate;
        }
      }
    }

    for (var j = 0; j < pairProduct.variants.length; j++) {
      if (pairProduct.variants[j].available) {
        return pairProduct.variants[j];
      }
    }

    return pairProduct.variants[0] || null;
  }

  function findPairVariantById(pairProduct, variantId) {
    if (!pairProduct || !pairProduct.variants) return null;

    for (var i = 0; i < pairProduct.variants.length; i++) {
      if (String(pairProduct.variants[i].id) === String(variantId)) {
        return pairProduct.variants[i];
      }
    }

    return null;
  }

  function setCardImage(img, url, alt) {
    if (!img || !url) return;

    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;

    if (alt) {
      img.alt = alt;
    }
  }

  function getPairProductUrl(pairProduct, variant) {
    if (!pairProduct || !pairProduct.url) return '';

    var url = String(pairProduct.url);
    if (variant && variant.id) {
      url += (url.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + encodeURIComponent(variant.id);
    }

    return url;
  }

  function getMainVariantImage(configVariant, eventVariant) {
    if (eventVariant && eventVariant.featured_image_full) {
      return eventVariant.featured_image_full;
    }

    if (configVariant && configVariant.image) {
      return configVariant.image;
    }

    return null;
  }

  function initSection(section) {
    if (!section || section.dataset.completeSetInit === 'true') return;
    section.dataset.completeSetInit = 'true';

    var config = readConfig(section);
    if (!config || !config.pairProducts || !config.pairProducts.length) return;

    var state = {
      mainVariant: findMainVariant(config, config.mainVariantId),
      pairProduct: config.pairProducts[0],
      pairVariant: null,
      pairIndex: 0,
      pairVariantManual: false
    };

    var els = {
      mainImage: section.querySelector('[data-complete-set-main-image]'),
      mainLabel: section.querySelector('[data-complete-set-main-label]'),
      mainPrice: section.querySelector('[data-complete-set-main-price]'),
      pairImage: section.querySelector('[data-complete-set-pair-image]'),
      pairImageLink: section.querySelector('[data-complete-set-pair-image-link]'),
      pairTitle: section.querySelector('[data-complete-set-pair-title]'),
      pairTitleLink: section.querySelector('[data-complete-set-pair-title-link]'),
      pairPrice: section.querySelector('[data-complete-set-pair-price]'),
      pairVariantSelect: section.querySelector('[data-complete-set-pair-variant]'),
      compareTotal: section.querySelector('[data-complete-set-compare-total]'),
      setTotal: section.querySelector('[data-complete-set-set-total]'),
      saveBadge: section.querySelector('[data-complete-set-save-badge]'),
      atc: section.querySelector('[data-complete-set-atc]'),
      atcLabel: section.querySelector('[data-complete-set-atc-label]'),
      atcSub: section.querySelector('[data-complete-set-atc-sub]'),
      pickers: section.querySelectorAll('[data-complete-set-picker]')
    };

    var ctaSavePrefix = config.ctaSavePrefix || 'You save';
    var matchOptionIndex = config.matchOptionIndex || 0;

    function getPricing() {
      var combinedSell = 0;
      var combinedCompare = 0;

      if (state.mainVariant) {
        combinedSell += state.mainVariant.price || 0;
        combinedCompare += getCompareCents(state.mainVariant);
      }

      if (state.pairVariant) {
        combinedSell += state.pairVariant.price || 0;
        combinedCompare += getCompareCents(state.pairVariant);
      }

      var setPrice =
        config.bundlePriceCents > 0 && config.bundlePriceCents < combinedSell
          ? config.bundlePriceCents
          : combinedSell;

      var saveCents = 0;
      if (config.bundlePriceCents > 0 && combinedSell > config.bundlePriceCents) {
        saveCents = combinedSell - config.bundlePriceCents;
      } else if (combinedCompare > setPrice) {
        saveCents = combinedCompare - setPrice;
      }

      return {
        combinedSell: combinedSell,
        combinedCompare: combinedCompare,
        setPrice: setPrice,
        saveCents: saveCents,
        showCompare: combinedCompare > setPrice
      };
    }

    function updateOfferDisplay() {
      var pricing = getPricing();

      if (els.setTotal) {
        els.setTotal.textContent = formatMoney(pricing.setPrice);
      }

      if (els.compareTotal) {
        if (pricing.showCompare) {
          els.compareTotal.textContent = formatMoney(pricing.combinedCompare);
          els.compareTotal.hidden = false;
        } else {
          els.compareTotal.hidden = true;
        }
      }

      if (els.saveBadge) {
        if (pricing.saveCents > 0) {
          els.saveBadge.textContent = 'Save ' + formatMoney(pricing.saveCents);
          els.saveBadge.hidden = false;
        } else {
          els.saveBadge.hidden = true;
        }
      }

      if (els.atcSub) {
        if (pricing.saveCents > 0) {
          els.atcSub.textContent = ctaSavePrefix + ' ' + formatMoney(pricing.saveCents) + ' on this set';
          els.atcSub.hidden = false;
        } else {
          els.atcSub.hidden = true;
        }
      }
    }

    function updateAtcState() {
      if (!els.atc) return;

      var available =
        state.mainVariant &&
        state.mainVariant.available &&
        state.pairVariant &&
        state.pairVariant.available;

      els.atc.disabled = !available;

      if (els.atcLabel) {
        els.atcLabel.textContent = available
          ? els.atc.getAttribute('data-default-label') || 'Add both to cart'
          : els.atc.getAttribute('data-sold-out-label') || 'Sold out';
      }
    }

    function renderMainCard() {
      if (!state.mainVariant) return;

      var label = getVariantLabel(state.mainVariant, matchOptionIndex);

      if (els.mainLabel) {
        if (label) {
          els.mainLabel.textContent = label;
          els.mainLabel.hidden = false;
        } else {
          els.mainLabel.textContent = '';
          els.mainLabel.hidden = true;
        }
      }

      if (els.mainPrice) {
        els.mainPrice.textContent =
          state.mainVariant.priceFormatted || formatMoney(state.mainVariant.price);
      }

      if (els.mainImage) {
        var mainImageUrl = state.mainVariant.image;
        var mainAlt = label ? (config.mainTitle || '') + ' — ' + label : config.mainTitle || '';
        if (mainImageUrl) {
          setCardImage(els.mainImage, mainImageUrl, mainAlt);
        }
      }
    }

    function populatePairVariantSelect() {
      if (!els.pairVariantSelect || !state.pairProduct) return;

      var previousValue = els.pairVariantSelect.value;
      els.pairVariantSelect.innerHTML = '';

      var variants = state.pairProduct.variants || [];
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = getVariantLabel(variant, matchOptionIndex) || variant.label || 'Variant';
        if (!variant.available) {
          option.disabled = true;
          option.textContent += ' — Sold out';
        }
        els.pairVariantSelect.appendChild(option);
      }

      if (state.pairVariant) {
        els.pairVariantSelect.value = String(state.pairVariant.id);
      } else if (previousValue) {
        els.pairVariantSelect.value = previousValue;
      }
    }

    function updatePairLinks() {
      var url = getPairProductUrl(state.pairProduct, state.pairVariant);

      if (els.pairImageLink) {
        els.pairImageLink.href = url || '#';
      }

      if (els.pairTitleLink) {
        els.pairTitleLink.href = url || '#';
      }
    }

    function applyPairVariant(variant) {
      state.pairVariant = variant || null;

      if (els.pairVariantSelect && variant) {
        els.pairVariantSelect.value = String(variant.id);
      }

      if (!state.pairVariant) {
        updatePairLinks();
        updateOfferDisplay();
        updateAtcState();
        return;
      }

      if (els.pairPrice) {
        els.pairPrice.textContent =
          state.pairVariant.priceFormatted || formatMoney(state.pairVariant.price);
      }

      if (els.pairImage && state.pairVariant.image) {
        var pairLabel = getVariantLabel(state.pairVariant, matchOptionIndex);
        var pairAlt =
          pairLabel && state.pairProduct
            ? state.pairProduct.title + ' — ' + pairLabel
            : state.pairProduct ? state.pairProduct.title : '';
        setCardImage(els.pairImage, state.pairVariant.image, pairAlt);
      }

      updatePairLinks();
      updateOfferDisplay();
      updateAtcState();
    }

    function renderPairCard() {
      if (els.pairTitle && state.pairProduct) {
        els.pairTitle.textContent = state.pairProduct.title;
      }

      populatePairVariantSelect();

      if (!state.pairVariantManual) {
        applyPairVariant(
          findMatchedPairVariant(state.pairProduct, state.mainVariant, matchOptionIndex)
        );
        return;
      }

      var selectedId = els.pairVariantSelect ? els.pairVariantSelect.value : '';
      var current =
        findPairVariantById(state.pairProduct, selectedId) ||
        findMatchedPairVariant(state.pairProduct, state.mainVariant, matchOptionIndex);

      applyPairVariant(current);
    }

    function setMainVariant(variant, eventVariant) {
      if (!variant && !eventVariant) return;

      var matched = variant || findMainVariant(config, eventVariant.id);
      state.mainVariant = enrichMainVariant(matched, eventVariant);

      var resolvedImage = getMainVariantImage(matched, eventVariant);
      if (resolvedImage) {
        state.mainVariant.image = resolvedImage;
      }

      state.pairVariantManual = false;
      renderMainCard();
      renderPairCard();
    }

    function setPairIndex(index) {
      if (!config.pairProducts[index]) return;

      state.pairIndex = index;
      state.pairProduct = config.pairProducts[index];
      state.pairVariantManual = false;

      els.pickers.forEach(function (picker) {
        var isActive = String(picker.getAttribute('data-pair-index')) === String(index);
        picker.classList.toggle('is-active', isActive);
        picker.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      renderPairCard();
    }

    function addBothToCart() {
      if (!state.mainVariant || !state.pairVariant || !els.atc) return;
      if (!state.mainVariant.available || !state.pairVariant.available) return;

      els.atc.classList.add('is-loading');
      els.atc.disabled = true;

      var bundleId =
        'complete-set-' +
        String(config.mainProductId) +
        '-' +
        String(state.pairProduct.id) +
        '-' +
        Date.now();

      var items = [
        {
          id: state.mainVariant.id,
          quantity: 1,
          properties: {
            _bundle_id: bundleId,
            _bundle_type: 'complete-set'
          }
        },
        {
          id: state.pairVariant.id,
          quantity: 1,
          properties: {
            _bundle_id: bundleId,
            _bundle_type: 'complete-set'
          }
        }
      ];

      if (config.bundlePriceCents > 0) {
        items[0].properties._bundle_price = String(Math.round(config.bundlePriceCents / 100));
        items[1].properties._bundle_price = String(Math.round(config.bundlePriceCents / 100));
      }

      var payload = { items: items };

      if (window.RabitatCart && typeof window.RabitatCart.withCartSections === 'function') {
        payload = window.RabitatCart.withCartSections(payload);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw err;
            });
          }
          return response.json();
        })
        .then(function (result) {
          if (window.RabitatCart && typeof window.RabitatCart.handleMutationResult === 'function') {
            window.RabitatCart.handleMutationResult(result, {
              open: true,
              focus: false,
              animate: false
            });
          } else if (window.RabitatCart && typeof window.RabitatCart.syncCartAfterAdd === 'function') {
            window.RabitatCart.syncCartAfterAdd(result);
          } else {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: result }));
          }
        })
        .catch(function (error) {
          console.error('Complete the set add error:', error);
        })
        .finally(function () {
          els.atc.classList.remove('is-loading');
          updateAtcState();
        });
    }

    function onVariantChanged(event) {
      if (!event.detail || !event.detail.variant) return;

      var eventVariant = event.detail.variant;
      var matched = findMainVariant(config, eventVariant.id);
      setMainVariant(matched, eventVariant);
    }

    els.pickers.forEach(function (picker) {
      picker.addEventListener('click', function () {
        var index = parseInt(picker.getAttribute('data-pair-index'), 10);
        if (!isNaN(index)) setPairIndex(index);
      });
    });

    if (els.pairVariantSelect) {
      els.pairVariantSelect.addEventListener('change', function () {
        var variant = findPairVariantById(state.pairProduct, els.pairVariantSelect.value);
        if (!variant) return;

        state.pairVariantManual = true;
        applyPairVariant(variant);
      });
    }

    if (els.atc) {
      els.atc.addEventListener('click', addBothToCart);
    }

    document.addEventListener('rabitat:variant:changed', onVariantChanged);
    document.addEventListener('variant:changed', onVariantChanged);

    var liveVariantId = getLiveMainVariantId();
    if (liveVariantId && String(liveVariantId) !== String(config.mainVariantId)) {
      var liveMatch = findMainVariant(config, liveVariantId);
      if (liveMatch) {
        state.mainVariant = liveMatch;
      }
    }

    renderMainCard();
    renderPairCard();
  }

  function initAll() {
    document.querySelectorAll('[data-rabitat-pdp-complete-set]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    var section = event.target.querySelector('[data-rabitat-pdp-complete-set]');
    if (section) initSection(section);
  });
})();
